import { Rule, SchematicContext, SchematicsException, Tree } from '@angular-devkit/schematics';
import { virtualFs, workspaces } from '@angular-devkit/core';
import { NodePackageInstallTask } from '@angular-devkit/schematics/tasks';

// Add and configure library in the aplication
export function ngAdd(options: any): Rule {
  return async (tree: Tree, context: SchematicContext) => {
    console.log("## Instaling the FirstFactory angular component library.");

    const host = createHost(tree);
    const { workspace } = await workspaces.readWorkspace('/', host);
    if (!options.project) {
      options.project = workspace.extensions.defaultProject;
    }

    const project = workspace.projects.get(options.project);
    if (!project) {
      throw new SchematicsException(`Invalid project name: ${options.project}`);
    }
    
    // First
    context.addTask(new NodePackageInstallTask());
    
    let buffer = tree.read(project.sourceRoot+'/index.html');
    if(buffer) {
      
      // Font tags used on the library that need to be added to the main app
      const fontTags = [
        `<link href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap" rel="stylesheet">`,
        `<link href='https://fonts.googleapis.com/css?family=Lato&subset=latin,latin-ext' rel='stylesheet' type='text/css'>`,
        `<link href="https://fonts.googleapis.com/css?family=Montserrat" rel="stylesheet">`,
        `<link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet">`
      ];

      const insertIndex = buffer.toString().indexOf('</head>');
      const recorder = tree.beginUpdate('src/index.html');

      // Insert only missing tags
      for(let fontTag of fontTags){
        if(buffer.toString().indexOf(fontTag) === -1){
          recorder.insertLeft(insertIndex, `\t${fontTag}\n`);
        }
      }

      tree.commitUpdate(recorder);
      
    }
    
    const styleTheme = `@import '~@ffcarlosmora/component-library-angular/theming'`;
    
    buffer = tree.read(project.sourceRoot+'/styles.scss');
    if(buffer && buffer.toString().indexOf(styleTheme) === -1) {
      const recorder = tree.beginUpdate('src/styles.scss');
      recorder.insertLeft(0, styleTheme+`;\n`);
      tree.commitUpdate(recorder);
    }

    buffer = tree.read(project.sourceRoot+'/styles.sass');
    if(buffer && buffer.toString().indexOf(styleTheme) === -1) {
      const recorder = tree.beginUpdate('src/styles.sass');
      recorder.insertLeft(0, styleTheme+`\n`);
      tree.commitUpdate(recorder);
    }
    
  };
}


function createHost(tree: Tree): workspaces.WorkspaceHost {
  return {
    async readFile(path: string): Promise<string> {
      const data = tree.read(path);
      if (!data) {
        throw new SchematicsException('File not found.');
      }
      return virtualFs.fileBufferToString(data);
    },
    async writeFile(path: string, data: string): Promise<void> {
      return tree.overwrite(path, data);
    },
    async isDirectory(path: string): Promise<boolean> {
      return !tree.exists(path) && tree.getDir(path).subfiles.length > 0;
    },
    async isFile(path: string): Promise<boolean> {
      return tree.exists(path);
    },
  };
}